import {sellerConstants } from '../../_constants/seller.constants';

const initialState = { loading : true, countries: '', error: false};

export function countries(state = initialState, action) {
    switch (action.type) {
      case sellerConstants.REQUEST_COUNTRIES:
        return {
          loading: true,
          countries: '',
          error: false
        };
      case sellerConstants.RECEIVE_COUNTRIES:
        return {
          loading: false,
          countries: action.countries.data.country_list,
          error: false
        };
      case sellerConstants.COUNTRY_LIST_ERROR:
        return { 
          loading: false,
          countries: '',
          error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/sellers/country.reducer.js